import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { isNullOrEmpty } from '../../../../utils/util';

const PabReplanningListItemSupplier = (props) => {

    const getSupplierName = (text) => {
        if (!isNullOrEmpty(text)) {
            const supplier = text.trim().split(/\s+/);
            return supplier.slice(0, 2).join(' ');
        }
        else {
            return text;
        }
    };


    return (
        <Link
            className="row"
            style={{ display: 'block' }}
            to={{
                pathname: props.route, state: { subtitle: `Fornecedor: ${props.data.key}-${getSupplierName(props.data.value)}` }
            }}
            onClick={(event) => {
                if (props.onSelectChange) {
                    props.onSelectChange(event);
                }
            }}
        >
            <div className="input-field col s12">
                <strong><span className="title sixth-text-color">{`${props.data.key}`}</span></strong>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{getSupplierName(props.data.value)}</span>
            </div>
        </Link>
    );
};

export default withRouter(withTranslation()(PabReplanningListItemSupplier));
